<template>
  <div class="grid-x spotlight" :style="{ backgroundColor: backgroundColour }">
    <div
      v-for="(item, index) in items"
      class="cell small-12 large-auto"
      :key="'item:' + index"
    >
      <v-text
        class="text-content"
        :class="{ '-last': index == items.length - 1 }"
        :text="item.content.text"
        :isWhite="true"
      />
    </div>
  </div>
</template>

<script>
import VText from "./Text";

export default {
  components: {
    VText,
  },
  props: {
    backgroundColour: String,
    items: Array,
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.spotlight {
  margin: vw-relative(20 0, 320);
  @include breakpoint(medium) {
    margin: vw-relative(30 0);
    margin-left: -10%;
    width: 120%;
  }
}
.cell {
  display: flex;
  flex-direction: column;
}
.text-content {
  flex: 1 0 0%;
  padding: vw-relative(16 0, 320);
  margin: vw-relative(0 16, 320);
  text-align: center;
  border-bottom: 1px solid #6b2377;
  &.-last {
    border: 0;
  }
  @include breakpoint(large) {
    padding: vw-relative(0 32);
    margin: vw-relative(32 0);
    border-bottom: 0;
    border-right: 1px solid #6b2377;
  }
}
</style>
